import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {CallLogEntryModel} from '@app/models/call-log-entry.model';
import {ContactModel} from '@app/models/contact.model';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtCallControlService} from '@app/services/gt-call-control.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {ContactDetailComponent} from '@app/shared/contact-detail/contact-detail.component';
import {of} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {CallLogDataSource} from './eu-call-log.datasource';

@Component({
  selector: 'gt-call-log',
  templateUrl: './eu-call-log.component.html',
  styleUrls: ['./eu-call-log.component.scss']
})
export class EuCallLogComponent implements OnInit {
  callLog: CallLogEntryModel[] = [];
  dataSource: CallLogDataSource | null;
  displayedColumns = ['time', 'trigger', 'caller', 'duration'];
  filterStr = '';

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private callControlService: GtCallControlService,
    private notificationService: GtNotificationService,
    private authenticationService: GtAuthenticationService,
    private directoryService: GtDirectoryService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.callControlService.getEndUserCallLog().subscribe(
      r => {
        this.callLog = r.map(CallLogEntryModel.convertEndUserCallLogEntry);
        this.dataSource = new CallLogDataSource(this.callLog, this.sort, this.paginator);
      },
      e => this.notificationService.errorNotification.next(e)
    );
  }

  onFilterInput(event: KeyboardEvent) {
    if (!this.dataSource) {
      return;
    }
    this.dataSource.filter = (event.target as HTMLInputElement).value.replace(/ /g, '');
  }

  handleRowClick(entry: CallLogEntryModel) {
    this.directoryService
      .getContactByFullNumber(this.authenticationService.oname, entry.fullNumber)
      .pipe(
        map(contact => ContactModel.convertContactModel(contact.backendModel)),
        catchError(_ => of(ContactModel.convertCallLogEntryModel(entry))),
        tap(contact => this.openDialog(contact))
      )
      .subscribe();
  }

  private openDialog(contact: ContactModel) {
    const dialogRef = this.dialog.open(ContactDetailComponent, {minWidth: 500});
    dialogRef.componentInstance.contact = contact;
    dialogRef.componentInstance.back.subscribe(() => {
      dialogRef.close();
    });
  }

  clearFilter(): void {
    this.filterStr = '';
    this.dataSource.filter = '';
  }
}
